import React from 'react'
import { Card, Row, Col, Typography, Space, Button, Statistic } from 'antd'
import { Link } from 'react-router-dom'
import { 
  BookOutlined, 
  SearchOutlined, 
  FileTextOutlined,
  HistoryOutlined,
  RightOutlined 
} from '@ant-design/icons'
import './Home.css'

const { Title, Paragraph } = Typography

function Home() {
  const features = [
    {
      icon: <SearchOutlined />,
      title: '全文搜索',
      description: '基于 FTS5 的强大全文搜索引擎，支持中文分词，快速定位所需内容'
    },
    {
      icon: <BookOutlined />,
      title: '海量典籍',
      description: '收录上万部中国古代文献，涵盖经史子集四部分类，内容丰富全面'
    },
    {
      icon: <FileTextOutlined />,
      title: '智能分页',
      description: '支持按章节和字数两种分页模式，提供舒适的阅读体验'
    },
    {
      icon: <HistoryOutlined />,
      title: '传承文化',
      description: '致力于中华文化的数字化传承，让古代智慧在现代焕发新生'
    }
  ]

  const categories = [
    { key: 'jing', name: '经部', description: '儒家经典', count: 1200 },
    { key: 'shi', name: '史部', description: '历史典籍', count: 2800 },
    { key: 'zi', name: '子部', description: '诸子百家', count: 3500 },
    { key: 'ji', name: '集部', description: '文学总集', count: 2500 }
  ]

  return (
    <div className="home-container">
      {/* 英雄区域 */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <Title level={1} className="hero-title">
              五千年文库
            </Title>
            <Title level={3} className="hero-subtitle">
              传承千载文脉，汇聚万卷古籍
            </Title>
            <Paragraph className="hero-description">
              这里收藏着中华文明五千年的智慧结晶，从先秦诸子到明清小说，
              从经史子集到诗词歌赋。通过现代技术让古代文献触手可及，
              为研究者和爱好者提供便捷的检索和阅读体验。
            </Paragraph>
            <Space size="large" className="hero-actions">
              <Link to="/search">
                <Button type="primary" size="large" icon={<SearchOutlined />}>
                  开始搜索
                </Button>
              </Link>
              <Link to="/books">
                <Button size="large" icon={<BookOutlined />}>
                  浏览书籍
                </Button>
              </Link>
            </Space>
          </div>
          <div className="hero-stats">
            <Row gutter={[32, 16]}>
              <Col span={12}>
                <Statistic 
                  title="典籍总数" 
                  value={10000} 
                  suffix="部"
                  valueStyle={{ color: '#722ed1' }}
                />
              </Col>
              <Col span={12}>
                <Statistic 
                  title="文字总量" 
                  value={5} 
                  suffix="GB"
                  valueStyle={{ color: '#722ed1' }}
                />
              </Col>
            </Row>
          </div>
        </div>
      </section>

      {/* 功能特色 */}
      <section className="features-section">
        <div className="page-container">
          <Title level={2} className="section-title">
            核心功能
          </Title>
          <Row gutter={[24, 24]}>
            {features.map((feature, index) => (
              <Col xs={24} sm={12} lg={6} key={index}>
                <Card className="feature-card" hoverable>
                  <div className="feature-icon">
                    {feature.icon}
                  </div>
                  <Title level={4} className="feature-title">
                    {feature.title}
                  </Title>
                  <Paragraph className="feature-description">
                    {feature.description}
                  </Paragraph>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      {/* 分类导航 */}
      <section className="categories-section">
        <div className="page-container">
          <Title level={2} className="section-title">
            典籍分类
          </Title>
          <Row gutter={[24, 24]}>
            {categories.map((category) => (
              <Col xs={24} sm={12} lg={6} key={category.key}>
                <Link to={`/category/${category.key}`}>
                  <Card className="category-card" hoverable>
                    <div className="category-header">
                      <Title level={3} className="category-name">
                        {category.name}
                      </Title>
                      <RightOutlined className="category-arrow" />
                    </div>
                    <Paragraph className="category-description">
                      {category.description}
                    </Paragraph>
                    <Statistic 
                      value={category.count} 
                      suffix="部"
                      valueStyle={{ fontSize: '18px', color: '#722ed1' }}
                    />
                  </Card>
                </Link>
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </div>
  )
}

export default Home